import React, {Component} from 'react';
import {Link, NavLink} from 'react-router-dom';

class Header extends Component {
  render() {
    return (
      <header className="App-header">
        <div>
          <Link to="/">
            <button type="button" className="App-header-name">
              <span id="name">meredith young-ng</span>
            </button>
          </Link>
        </div>
        <div className="App-header-pages">
          <NavLink className={(navData) => (navData.isActive ? "active-style" : 'none')} to="/">
            <button type="button">
              <span id="buttonLink">about</span>
            </button>
          </NavLink>
          <NavLink className={(navData) => (navData.isActive ? "active-style" : 'none')} to="/work">
            <button type="button">
              <span id="buttonLink">work</span>
            </button>
          </NavLink>
          <NavLink className={(navData) => (navData.isActive ? "active-style" : 'none')} to="/music">
            <button type="button">
              <span id="buttonLink">music</span>
            </button>
          </NavLink>
        </div>
      </header>
    );
  }
}

export default Header;
